import "./product_list_on_sale.scss"

onReady(() => {
  // zmena poradia na desktope
  document.getElementById("id_poradie").addEventListener("change", (evt) => {
    window.location.href =
      window.location.pathname + "?poradie=" + evt.target.value
  })

  // zmena poradia na mobile
  const mobileOrderSubmitBtn = document.getElementById("order-submit")

  document.querySelectorAll(".order-input").forEach((orderInput) => {
    orderInput.addEventListener("click", () => {
      mobileOrderSubmitBtn.setAttribute("href", "?poradie=" + orderInput.value)
    })
  })
})
